define('views/pages/trade/offer/basket',['require','views/base/view','views/base/collection','text!templates/pages/trade/offer/basket.ejs','text!templates/pages/trade/offer/basket-row.ejs'],function(require) {
    'use strict';

    var View = require('views/base/view'),
        CollectionView = require('views/base/collection'),
        templateBasket = require('text!templates/pages/trade/offer/basket.ejs'),
        templateBasketRow = require('text!templates/pages/trade/offer/basket-row.ejs');

    /*
        TRADE BASKET TABLE ROW
    */

    var TradeBasketRowView = View.extend({
        template: templateBasketRow,
        className: 'trade-table-row',
        tagName: 'tr',
        listen: {
            'change:amount model': 'render',
            'change:selected model': 'render',
            'change:comment model': 'render'
        },
        initialize: function() {
            View.prototype.initialize.apply(this, arguments);

            this.delegate('click', this.clickRow);
            this.delegate('click', '.btn-danger', this.deleteClick);
            this.delegate('click', '.trade-table-name a', this.clickCard);
        },

        render: function() {
            this.destroyTooltip();

            View.prototype.render.apply(this, arguments);
            if (this.model.get('selected')) {
                this.$el.addClass('active');
            } else {
                this.$el.removeClass('active');
            }

            this.$('.trade-table-comment i').tooltip({ container: 'body', placement: 'bottom' });
        },

        clickRow: function(ev) {
            ev.stopPropagation();
            ev.preventDefault();

            var item = this.model.collection.findWhere({ selected: true });
            if (item && item !== this.model) {
                item.set('selected', false);
            }
            this.model.set('selected', true);

            this.publishEvent('selectBasketRow', this.model);
        },

        scrollToThis: function() {
            var top = this.$el.position().top + this.$el.parent().scrollTop();
            this.$el.parent().scrollTop(top);
        },

        deleteClick: function(ev) {
            ev.stopPropagation();
            ev.preventDefault();

            this.model.destroy();
        },

        clickCard: function() {
            this.publishEvent('openOrgOfferCard', this.model);
            return 0;
        },

        dispose: function() {
            if (this.disposed) { return; }

            this.destroyTooltip();

            View.prototype.dispose.apply(this, arguments);
        },

        destroyTooltip: function() {
            this.$('.trade-table-comment i').tooltip('destroy');
        }
    });


    /*
        TRADE BASKET TABLE
    */

    var TradeBasketView = CollectionView.extend({
        autoRender: true,
        template: templateBasket,
        itemView: TradeBasketRowView,
        region: 'trade-offer-basket',
        listSelector: '#trade-basket-table tbody',

        renderItems: true,

        initialize: function() {
            CollectionView.prototype.initialize.apply(this, arguments);

            this.subscribeEvent('selectTradeRow', this.onSelectTradeRow);
        },

        onSelectTradeRow: function(itemT) {
            var found, item;

            found = this.collection.findWhere({
                idTradeGoods: itemT.idTradeGoods,
                idOrganizationOffer: itemT.idOrganizationOffer
            });

            if (found) {
                item = this.collection.findWhere({ selected: true });
                if (item && item !== found) {
                    item.set('selected', false);
                }
                found.set('selected', true);

                this.subview('itemView:' + found.cid).scrollToThis();
            }
        }
    });

    return TradeBasketView;
});

